module.exports = __webpack_public_path__ + "static/media/destinationInfoSkeletonXs.3a4ffea5.svg";